import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isDateBetween } from '../../helpers/date-between.helper';

@Injectable({
  providedIn: 'root'
})
export class MaintenceGuard  {
  constructor(
    private router: Router,
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree {
      const { activar, inicio, fin} = environment.cotizacionOff;
      const underMaintence = isDateBetween(inicio,fin) && activar;
      console.log('underMaintence', underMaintence, 'inicio', inicio, 'fin', fin, 'activar', activar);
      return underMaintence ? this.router.createUrlTree(['/estamos-en-mantenimiento']):true;

  }
  
}
